
    import { mapActions, mapGetters } from "vuex"
    import { defineComponent } from "@vue/runtime-core"
    import { isDev } from "./helpers"
    import ApolloPlayground from "./components/misc/ApolloPlayground.vue"
    import ls from "local-storage"
    import gptAPI from "./api/gpt"
    import { PopupService } from "./helpers/popup.service"
    import CookieConsent from "./components/misc/CookieConsent.vue"
    const jwt = require('jsonwebtoken');

    export default defineComponent({
        components: {
            CookieConsent,
            ApolloPlayground,

        },
        data() {
            return {
                isDev,
                apiKey: ls("apiKey") as unknown as string,
                mode: ls("mode") as unknown as string || "server",
                popupService: new PopupService(),
            }
        },
        computed: {
            ...mapGetters(["user"]),

        },
        methods: {
            checkToken() {
                const token = (ls as any)("token")
                if (token) {
                    // Decode the payload part of the token
                    const payload = jwt?.decode && jwt?.decode(token)
    
                    // Extract the expiration time from the payload
                    const expirationTime = new Date(payload?.exp * 1000)
                    if (+expirationTime < +new Date()) {
                        (ls as any)("token", "")
                    }
                }
            },

            ...mapActions(["getPrompts", "getUser", "getCategories"]),
            updateApiKey(val: string) {
                this.apiKey = val
            },
            updateMode(val: string) {
                this.mode = val
            },
        },

        created () {
            this.checkToken()
            this.getUser()
            gptAPI.setApiKey(this.apiKey as unknown as string)
            this.apiKey
        },

    })

  